import { defineComponent as _defineComponent } from 'vue'
import LineSetTypeChip from "../shared/chip/LineSetTypeChip.vue";
import { computed, PropType } from "vue";
import { IReportHistory } from "@/domain/entities/report";
import dayjs from "dayjs";
import useGetLineRouteName from "@/use/useGetLineRouteName";
import DOMPurify from "dompurify";


const __default__ = {
  name: "BaseHistoryRow",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  reportHistory: {
    type: Object as PropType<IReportHistory>,
    required: true,
  },
},
  setup(__props, { expose: __expose }) {
  __expose();

const props = __props;

const WEEK_DAY = ["일", "월", "화", "수", "목", "금", "토"];

const onBoardDateTime = computed(() => {
  const onBoardDate = dayjs(props.reportHistory.realOnDtm);
  const date = onBoardDate.format("YYYY-MM-DD");
  const day = WEEK_DAY[onBoardDate.day()];

  return `${date}(${day})`;
});

const reportNameAndCountHTMLTexts = computed(() => {
  let htmlTexts = "";

  props.reportHistory.reportInfo.forEach((report, index, origin) => {
    const { reportName, count, color } = report;

    const comma = index === origin.length - 1 ? "" : ", ";
    const html = `
    <span style="color: ${color ?? "#000"}; line-height: 1;">
      ${reportName}(${count}회)<span style="color: #000; line-height: 1;">${comma}</span>
    </span>`;

    htmlTexts += html;
  });

  return htmlTexts;
});

const carNoAndVendor = computed(() => {
  const { vendorName, carNo } = props.reportHistory;
  if (!carNo && !vendorName) return "-";

  return `${carNo ?? "-"}(${vendorName ?? "-"})`;
});

const __returned__ = { props, WEEK_DAY, onBoardDateTime, reportNameAndCountHTMLTexts, carNoAndVendor, LineSetTypeChip, get useGetLineRouteName() { return useGetLineRouteName }, get DOMPurify() { return DOMPurify } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})